<template>
  <div class="componentBox">
    <h2 class="componentTitle">客户信息</h2>
    <Cell :colList="list" :detail="detail" />
    <Cell :colList="list2" :detail="detail" />
  </div>
</template>

<script>
import Cell from './Cell.vue';
export default {
  components: {Cell},
  props: ['detail'],
  data() {
    return {
      list: [
        {title: '客户姓名',field: 'customerName',},
        {title: '电话',field: 'customerPhone',},
        {title: '省市区/县',field: 'area',},
        {title: '详细地址',field: 'address',},
        {title: '动物类型',field: 'animalType',},
        {title: '养殖规模',field: 'farmScale',},
        {title: '饲养模式',field: 'feedMode',},
      ],
      list2: [
        {title: '业务员',field: 'salesManName',},
        {title: '所属工厂',field: 'factoryName',},
        {title: '聚落/片区',field: 'settlementName',},
      ],
    }
  },
  watch: {
    detail(){
      if(this.detail.animalType == '蛋鸡') this.list[5].title = '养殖规模（万羽）'
      if(this.detail.animalType == '蛋鸭') this.list[5].title = '养殖规模（千羽）'
    }
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {},
}
</script>
<style lang='scss'></style>
<style lang='scss' scoped></style>